import { Link } from "react-router-dom";

// Terminal state after a successful DELETE /account — deliberately a
// standalone, unauthenticated route (like /login) rather than an inline
// state on DeleteAccountPage; see that file's comment on why.
export function AccountDeletedPage() {
  return (
    <div className="card center-card">
      <h1>Account deleted</h1>
      <p className="meta">
        Your Prism account, its paired devices, and its server pairings have been removed.
      </p>
      <Link className="btn primary" to="/login">Sign in</Link>
    </div>
  );
}
